import type { ApiLink, ApiMe, Role } from '../api/types.js';
import { useMe } from '../api/hooks.js';
import { useWorkspaceId } from '../workspace.js';

interface CurrentMembership {
  userId: string;
  role: Role;
}

function currentMembership(me: ApiMe | undefined, workspaceId: string | null): CurrentMembership | null {
  if (!me || !workspaceId) return null;
  const w = me.workspaces.find((x) => x.id === workspaceId);
  if (!w) return null;
  return { userId: me.user.id, role: w.role };
}

export function useCanManageLink(): (link: ApiLink) => boolean {
  const { data: me } = useMe();
  const workspaceId = useWorkspaceId();
  const membership = currentMembership(me, workspaceId);
  return (link: ApiLink) => {
    if (!membership) return false;
    if (membership.role === 'owner' || membership.role === 'admin') return true;
    return link.created_by === membership.userId;
  };
}

export function useRole(): Role | null {
  const { data: me } = useMe();
  const workspaceId = useWorkspaceId();
  return currentMembership(me, workspaceId)?.role ?? null;
}
